<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
    @keydown.stop="onKeyDown($event)"
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      排版
    </div>

    <div class="settting-popup__content">
      <ul class="items">
        <li class="item">
          <div class="item__title">排版</div>
          <div class="item__main">
            <div
              class="text-direction" v-for="(v, i) in textDirections"
              :key="i"
              :class="{'is-selected': v.selected}"
              @click="setTextDirection(v)"
            >{{v.text}}</div>
          </div>
        </li>
        <li class="item">
          <div class="item__title">排版</div>
          <div class="item__main">
            <div class="text-align-wrapper">
              <div
                class="text-align" v-for="(v, i) in textAligns" :key="i"
                :class="{'is-selected': v.selected, 'is-vertical': isVertical}"
                @click="setTextAlign(v)"
              >
                <tal v-if="i === 0"></tal>
                <tac v-if="i === 1"></tac>
                <tar v-if="i === 2"></tar>
              </div>
            </div>
          </div>
        </li>
        <li class="item">
          <div class="item__title">行间距</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :step="0.1"
              :num-fixed="1"
              :min-val="1"
              :max-val="10"
              :number-unit="''"
              @updateValue="onLineSpaceUpdated"
              ref="lineSpaceSlider"
            ></slider>
          </div>
        </li>

        <li class="item">
          <div class="item__title">字间距</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :max-val="50"
              :number-unit="''"
              @updateValue="onLetterSpaceUpdated"
              ref="letterSpaceSlider"
            ></slider>
          </div>
        </li>

        <li class="item">
          <div class="item__title">透明度</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="'%'"
              @updateValue="onTransparentUpdated"
              ref="transparentSlider"
            ></slider>
          </div>
        </li>
      </ul>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../../mixins/popup.vue';
import slider from '../../popups/content/slider.vue';
import base from './base';
import tal from './tal';
import tac from './tac';
import tar from './tar';

export default {
  mixins: [popup, base],
  components: {
    slider,
    tal,
    tac,
    tar
  },
  data () {
    return {
      popupType: 'textAlignSetting',
      activeElement: null,
      textDirections: [
        {
          text: '横版',
          selected: false,
          value: 'Horizontal'
        }, {
          text: '竖版',
          selected: false,
          value: 'Vertical'
        }
      ],
      textAligns: [
        {
          name: 'left',
          selected: false
        }, {
          name: 'center',
          selected: false
        }, {
          name: 'right',
          selected: false
        }
      ],
      reports: {
        left: 'setting_type_panel,click_left_align,排版设置面板_左对齐',
        center: 'setting_type_panel,click_center_align,排版设置面板_居中对齐',
        right: 'setting_type_panel,click_right_align,排版设置面板_右对齐'
      }
    };
  },
  computed: {
    isVertical () {
      let v = (this.textDirections.filter(v => v.selected) || [])[0] || 'Horizontal';
      let isVertical = v.value === 'Vertical';
      return isVertical;
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.render();
          });
        }
      }
    }
  },
  created () {
    $(window).on('keydown', this.onKeyDown);
  },
  methods: {
    render () {
      const vm = this;

      this.renderTextDirectionsOptions();
      this.renderTextAlignsOptions();

      vm.$refs.lineSpaceSlider &&
        vm.$refs.lineSpaceSlider.updateValFromOutside(vm.sprite.lineHeight);

      vm.$refs.letterSpaceSlider &&
        vm.$refs.letterSpaceSlider.updateValFromOutside(vm.sprite.letterSpacing);

      vm.$refs.transparentSlider &&
        vm.$refs.transparentSlider.updateValFromOutside(vm.sprite.getTransparent());
    },

    renderTextDirectionsOptions () {
      for (let v of this.textDirections) {
        v.selected = this.sprite.versionAnyway === v.value;
      }
    },

    renderTextAlignsOptions () {
      for (let v of this.textAligns) {
        v.selected = this.sprite.font.textAlign === v.name;
      }
    },

    setTextDirection (obj) {
      switch (obj.value) {
        case 'Horizontal': // 横版
          this.$analysis('setting_type_panel,click_horizon_set,排版设置面板_横版');
          this.sprite.setversionAnyway();
          break;
        case 'Vertical': // 竖版
          this.$analysis('setting_type_panel,click_vertical_set,排版设置面板_竖版');
          if (
            this.sprite.artType ||
            (this.sprite.font.textDecoration && this.sprite.font.textDecoration == 'underline') ||
            (this.sprite.font.fontStyle && this.sprite.font.fontStyle == 'italic')
          ) {
            this.$message({
              showClose: true,
              message: '你好！竖版文字不支持艺术字效果和下划线、倾斜样式，如需使用请调整样式。'
            });
            return;
          }
          this.option.font.textDecoration = 'none';
          this.sprite.setversionAnyway('Vertical');

          break;
      }

      this.renderTextDirectionsOptions();
    },

    setTextAlign (obj) {
      this.$analysis(this.reports[obj.name]);
      this.updateSprite({
        textAlign: obj.name
      })
        .then(() => {
          this.$refs.letterSpaceSlider &&
            this.$refs.letterSpaceSlider.focusInput();
        });

      for (let v of this.textAligns) {
        v.selected = obj.name === v.name;
      }
    },

    onLineSpaceUpdated (val, undo = false, msg, oldVal) {
      this.TOOL.updateSprite(this.sprite.id, {
        lineHeight: val
      }, this.sprite.scenesId, false)
        .then(() => {
          if (undo) {
            let data = {};
            data.id = this.sprite.id;
            data.scenesId = this.sprite.scenesId;
            data.reData = {lineHeight: oldVal};
            data.data = {lineHeight: val};
            eve('undo_redo', null, {type: 'textSpacing', data: data});
          }
        });
      if (undo) {
        this.$analysis('setting_type_panel,drag_line_distance_set,排版设置面板_行间距');
      }
    },

    onLetterSpaceUpdated (val, undo = false, msg, oldVal) {
      this.TOOL.updateSprite(this.sprite.id, {
        letterSpacing: val
      }, this.sprite.scenesId, false)
        .then(() => {
          if (undo) {
            let data = {};
            data.id = this.sprite.id;
            data.scenesId = this.sprite.scenesId;
            data.reData = {letterSpacing: oldVal};
            data.data = {letterSpacing: val};
            eve('undo_redo', null, {type: 'textSpacing', data: data});
          }
        });
      if (undo) {
        this.$analysis('setting_type_panel,drag_font_distance_set,排版设置面板_字间距');
      }
    },

    onTransparentUpdated (val, undo) {
      this.sprite.setTransparent({
        percent: val,
        undo
      });
    },

    onKeyDown (ev) {
      if (ev.key === 'ArrowUp' || ev.key === 'ArrowDown') {
        let target = ev.target;
        if (target.tagName === 'INPUT') {
          this.activeElement = target;
        }
        if (target.tagName === 'BODY' && this.activeElement) {
          this.activeElement.focus();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  box-shadow: #d8dee9 0px 0px 5px 0px;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 0 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 36px;
  }

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }
}

.text-direction {
  display: inline-block;
  width: 60px;
	height: 34px;
  line-height: 34px;
	background-color: #f0f0f8;
  border: solid 2px #f0f0f8;
  margin-right: 25px;
  cursor: pointer;

  &:last-of-type {
    margin-right: 0;
  }

  &.is-selected {
	  border: solid 2px #5778fb;
  }
}

.text-align-wrapper {
  display: flex;
  align-items: center;
}

.text-align {
  display: inline-block;
  width: 17px;
  height: 17px;
  margin-right: 25px;
  cursor: pointer;
  transition-duration: 0.3s;

  &.is-vertical {
    transform: rotate(90deg);
  }
}

</style>

<style lang="scss">
.text-align {
  .st0{fill:#474261;}

  &.is-selected {
    .st0 {
      fill:#5778fb;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popupsNew/textSetting/alignSetting.vue